import React from 'react';
import { IconProps } from '.';

const SvgUnfold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M17.53 14.53 12 20.06l-5.53-5.53 1.06-1.06L12 17.94l4.47-4.47 1.06 1.06ZM17.53 9.47l-1.06 1.06L12 6.06l-4.47 4.47-1.06-1.06L12 3.94l5.53 5.53Z'
      />
    </svg>
  );
};

export default SvgUnfold;
